import { CheckMarkFillLegacy } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box } from '@lyearn/ui';
import { Image } from '@/components/Image';
import { ImageTypeEnum } from '@/modules/events/views/EventEditor/components/AddCover/const';

import { RANDOM_CARD_NAME } from '../hooks/useImageList';
import RandomCard from '../RandomCard';
import { containerStyles, imageContainerStyles, selectedContainerStyles } from '../styles';
import { ImageCardProps } from './types';

const ImageCard: React.FC<ImageCardProps> = (props) => {
  const { selectedCard, coverUrl, cardItem, onClick } = props;
  return (
    <Box
      className={cn(
        'relative p-2',
        selectedCard?.url === cardItem.url ? selectedContainerStyles : containerStyles,
      )}>
      <Box className={cn('cursor-pointer', imageContainerStyles)} onClick={() => onClick(cardItem)}>
        {cardItem.name === RANDOM_CARD_NAME ? (
          <RandomCard />
        ) : (
          <Image
            alt={cardItem.name}
            className="h-full w-full rounded-8 border border-border"
            layout="fill"
            objectFit={cardItem.type == ImageTypeEnum.Badges ? 'contain' : 'cover'}
            src={cardItem.thumbUrl ?? cardItem.url}
            style={{ objectFit: 'contain' }}
          />
        )}
      </Box>
      {cardItem.url === coverUrl && selectedCard?.url === coverUrl ? (
        <CheckMarkFillLegacy className="absolute -top-8 h-24 w-24 rounded bg-bg-secondary fill-current text-interactive-primary -end-8" />
      ) : null}
    </Box>
  );
};

export default ImageCard;
